import { render, staticRenderFns } from "./NextStepsSlide.vue?vue&type=template&id=04d2277c&scoped=true&"
import script from "./NextStepsSlide.vue?vue&type=script&lang=ts&"
export * from "./NextStepsSlide.vue?vue&type=script&lang=ts&"
import style0 from "./NextStepsSlide.vue?vue&type=style&index=0&id=04d2277c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2277c",
  null
  
)

export default component.exports